import { Button, Form, FormInstance, Input, message, Typography } from "antd";
import classes from "./styles.module.css";
import { useEffect, useRef, useState } from "react";
import { VALIDATION } from "constants/strings";
import { getEstimatedCredits } from "utils";
import { useList } from "@refinedev/core";
import { LoadingSpinner } from "components/LoadingSpinner";

type Configuration = {
  maxModes: number;
  maxPhotons: number;
};

export const CreditsCalculatorTab = () => {
  const formRef = useRef<FormInstance | null>(null);
  const [result, setResult] = useState<number | null>(null);

  const { data, isLoading } = useList({
    resource: "configure"
  });

  const configuration = data?.data?.[0] as Configuration;

  const handleSubmit = async () => {
    const formData = formRef.current?.getFieldsValue();
    const { estimatedCredits } = await getEstimatedCredits(formData);
    setResult(estimatedCredits);
  };

  useEffect(() => {
    return () => {
      setResult(null);
    };
  }, []);

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className={classes.formContainer}>
      <Typography.Text className={classes.creditCalculatorInfoText}>
        Are you unsure how many credits you need to run you calculation?
      </Typography.Text>

      <Form
        onFinish={handleSubmit}
        ref={formRef}
        style={{ width: "100%" }}
        key={"Calculator"}
        layout="vertical"
        requiredMark={false}>
        <Form.Item
          name="nPhotons"
          label="Number of input photons"
          className={classes.inputField}
          normalize={(value) => (value?.toString() || "").replace(/[^0-9]/g, "")}
          rules={[
            {
              required: true,
              message: VALIDATION.fieldIsRequired
            },
            {
              validator(_, value) {
                if (!value) return Promise.resolve();

                const numPhotons = Number(value);

                if (numPhotons <= 0) {
                  return Promise.reject(VALIDATION.getMinValidationMessage(0));
                }

                if (numPhotons > configuration.maxPhotons) {
                  return Promise.reject(
                    VALIDATION.getMaxValidationMessage(configuration.maxPhotons)
                  );
                }

                return Promise.resolve();
              }
            }
          ]}>
          <Input />
        </Form.Item>

        <Form.Item
          name="nModes"
          label="Size of unitary"
          className={classes.inputField}
          normalize={(value) => (value?.toString() || "").replace(/[^0-9]/g, "")}
          rules={[
            {
              required: true,
              message: VALIDATION.fieldIsRequired
            },
            {
              validator(_, value) {
                if (!value) return Promise.resolve();

                const numPhotons = Number(value);

                if (numPhotons <= 0) {
                  return Promise.reject(VALIDATION.getMinValidationMessage(0));
                }

                if (numPhotons > configuration.maxModes) {
                  return Promise.reject(VALIDATION.getMaxValidationMessage(configuration.maxModes));
                }

                return Promise.resolve();
              }
            }
          ]}>
          <Input />
        </Form.Item>

        {result && (
          <>
            <Typography.Paragraph style={{ margin: 0 }}>
              <span className={classes.amountText}>{result} </span>
              <span className={classes.creditText}>
                Credits required to complete your calculation (estimated)
              </span>
            </Typography.Paragraph>
            <br />
          </>
        )}

        <Button
          htmlType="submit"
          style={{
            backgroundColor: "#FF5A17",
            color: "#FFFFFF",
            borderColor: "#FF5A17",
            width: "100%",
            height: "44px",
            borderRadius: "8px",
            margin: "12 0",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "24px",
            padding: "10px 18px 10px 18px"
          }}>
          Run calculation
        </Button>
      </Form>

      <br />
    </div>
  );
};
